// src/stage2/characters/NPCController.jsx
import React, { useRef } from "react";
import NPCInteractable from "../conversation/NPCInteractable";
import { useConversation } from "../conversation/ConversationContext";
import NPCActor from "./NPCActor";
import PathMotion from "./PathMotion";

export default function NPCController({
  npcId,
  playerPosRef,

  interactRadius = 2.2,
  prompt = "...Talk...",
  onInteractText = "Beautiful morning, isn't it?",

  position = [0, 0, 0],
  rotation = [0, 0, 0],
  scale = 1,

  motion = null,

  modelUrl,
  actionUrls = [],
  startIndex = 0, // ✅ default animation index when NOT near
  preferredClipNames = [],
  cycle = true,
  cycleSeconds = 6,
  cycleDesyncSeconds = 0,

  // ✅ when near/talking, force this clip index (idle/listening)
  idleIndex = 0,
  idleWhenPaused = true,

  orbColor = "#7df4ff",
  orbSize = 0.45,
  orbPulse = true,
  orbOffset = [0, 0.06, 0],
  orbBoneNames = ["mixamorigHead", "Head", "mixamorigSpine2", "Hips"],
}) {
  const moverRef = useRef();
  const anchorRef = useRef();
  const { near, activeId } = useConversation();

  const isNear = near?.id === npcId;
  const isTalking = activeId === npcId;

  // pause motion when near OR talking
  const pauseMotion = isNear || isTalking;

  // when paused, force idle animation (instead of freezing whatever pose)
  const forcedIndex = idleWhenPaused && pauseMotion ? idleIndex : null;

  const actor = (
    <group
      ref={anchorRef}
      position={position}
      rotation={rotation}
      scale={scale}
    >
      <NPCActor
        modelUrl={modelUrl}
        actionUrls={actionUrls}
        preferredClipNames={preferredClipNames}
        startIndex={startIndex}            // ✅ ADD THIS
        cycle={cycle}
        cycleSeconds={cycleSeconds}
        cycleDesyncSeconds={cycleDesyncSeconds}
        forcedIndex={forcedIndex}          // ✅ keep this
        orbColor={orbColor}
        orbSize={orbSize}
        orbPulse={orbPulse}
        orbOffset={orbOffset}
        orbBoneNames={orbBoneNames}
      />
    </group>
  );

  if (!motion) {
    return (
      <NPCInteractable
        npcId={npcId}
        radius={interactRadius}
        prompt={prompt}
        onInteractText={onInteractText}
        playerPosRef={playerPosRef}
        targetRef={anchorRef}
      >
        {actor}
      </NPCInteractable>
    );
  }

  return (
    <NPCInteractable
      npcId={npcId}
      radius={interactRadius}
      prompt={prompt}
      onInteractText={onInteractText}
      playerPosRef={playerPosRef}
      targetRef={moverRef}
    >
      <PathMotion ref={moverRef} paused={pauseMotion} {...motion}>
        {actor}
      </PathMotion>
    </NPCInteractable>
  );
}
